/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Color scheme for form elements.
 */
export enum FORM_ELEMENT_COLOR_SCHEME {
  /**
   * Regular color scheme.
   */
  REGULAR = '',

  /**
   * Light color scheme.
   */
  LIGHT = 'light',
}
